import { createDraftSaveQueue } from '@/editor/core/draft-save-queue'
import { saveProjectDraft } from '@/api/project-versions'
import { projectDraftResult, revisionPayload } from '@/utils/project-versions'
import { readStoredToken } from '@/api/http'

export default createDraftSaveQueue({
  scope: () => typeof localStorage === 'undefined' ? '' : readStoredToken(),
  async write (snapshot, status) {
    const payload = { ...revisionPayload(status), metadata: snapshot.metadata }
    if (snapshot.pageId) payload.pageId = snapshot.pageId
    if (snapshot.versionName !== undefined) payload.versionName = snapshot.versionName
    return projectDraftResult(await saveProjectDraft(snapshot.record.id, payload, { keepalive: true }), snapshot.record.id)
  }
})
